import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Página para mostrar cuando la ruta no existe (404)
 */
@Component({
  selector: 'app-not-found',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-col items-center justify-center h-screen bg-gray-100 dark:bg-gray-900">
      <div class="bg-white dark:bg-gray-800 p-10 rounded-lg shadow-lg text-center">
        <h1 class="text-6xl font-bold text-red-600 mb-4">404</h1>
        <h2 class="text-2xl font-semibold mb-2 text-gray-800 dark:text-gray-100">Página no encontrada</h2>
        <p class="text-gray-700 dark:text-gray-300 mb-6">
          La ruta que buscas no existe o fue movida.
        </p>
        <a routerLink="/" class="text-blue-500 dark:text-blue-400 hover:underline"
          >Volver al inicio</a
        >
      </div>
    </div>
  `,
  styles: ''
})
export class NotFoundComponent {}
